import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TableService } from '../services/table.service';

@Component({
    selector: 'pf-editable-table-actions',
    template: `
        <ng-container>
            @if (showUndoButton) {
                <pf-button
                    buttonType="undo"
                    (click)="undoChanges()"
                    [disabled]="!hasChanges"
                    >Undo Changes
                </pf-button>
            }
            @if (showSaveButton) {
                <pf-button
                    buttonType="submit"
                    (click)="saveEventHandler()"
                    [disabled]="!hasChanges"
                    >Save
                </pf-button>
            }
        </ng-container>
    `,
    styles: [
        `
            :host {
                display: flex;
                justify-content: flex-end;

                pf-button {
                    margin-left: var(--pf-gap);
                }
            }
        `,
    ],
    standalone: false,
})
export class EditableTableActionsComponent {
    private tableService = inject(TableService);

    hasChanges = false;

    @Input() showSaveButton = true;
    @Input() showUndoButton = true;

    @Output() saveChanges = new EventEmitter<void>();

    constructor() {
        this.tableService.editedTableData$.subscribe(editedData => {
            this.hasChanges = !!editedData.length;
        });
    }

    saveEventHandler() {
        this.saveChanges.emit();
    }

    undoChanges() {
        this.tableService.resetEditableTableState();
    }
}
